import { FilterState } from "../../../../state/AppState.ts";

export type ApiPayload = Omit<
  FilterState,
  "creation_date" | "contextual_relevancy"
> & {
  creation_date?: {
    start_date?: string;
    end_date?: string;
  };
  contextual_relevancy?: number[];
};

export class FilterPayloadMapper {
  frontendToApi = (mapperInput: {
    filters: Partial<FilterState>;
  }): ApiPayload =>
    structuredClone({
      ...mapperInput.filters,
      contextual_relevancy: this.transformContextualRelevancy(
        mapperInput.filters.contextual_relevancy,
      ),
      creation_date: this.transformCreationDate(
        mapperInput.filters.creation_date,
      ),
    });

  private transformContextualRelevancy = (
    payload: FilterState["contextual_relevancy"],
  ): ApiPayload["contextual_relevancy"] =>
    payload?.map((value) => parseInt(value));

  private transformCreationDate = (
    payload: FilterState["creation_date"],
  ): ApiPayload["creation_date"] => {
    if (!payload?.start?.year && !payload?.end?.year) return;

    const creation_date: ApiPayload["creation_date"] = {};

    if (payload.start?.year)
      creation_date.start_date = `${payload.start.year}-${payload.start.month || "01"}`;

    if (payload.end?.year)
      creation_date.end_date = `${payload.end.year}-${payload.end.month || "12"}`;

    return creation_date;
  };
}
